import { Route, NavigationGuardNext } from 'vue-router';
import store from '@/store';
import trackSeekerAccountCreation from '@/lib/tracking/segment_track_basic';

const SESSION_STORAGE_KEY = 'corporate_onboarding_segment_events_fired';

const corporateOnboardingSegmentGuard = (_to: Route, _from: Route, next: NavigationGuardNext) => {
  try {
    const account = store.getters['account/getAccount'];

    if (!account) {
      next();
      return;
    }

    const hasFiredEvents = sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';

    if (!hasFiredEvents) {
      const accountProperties = {
        firstName: account.firstName,
        lastName: account.lastName,
        email: account.email,
        familyType: account.accountType(),
      };

      trackSeekerAccountCreation(accountProperties);
      sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    }
  } catch (error) {
    console.error('Error in corporateOnboardingSegmentGuard:', error);
  }

  next();
};

export default corporateOnboardingSegmentGuard;
